import React, { useEffect, useState } from 'react';
import { CircularProgress, FormControlLabel, FormControl, Avatar } from '@material-ui/core';
import { getAllRooms } from '@/app/services/rooms/rooms';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import AnnouncementForm from './entireRoomAnnouncementForm';
import './../parentAnnouncement/parentAnnouncement.css';
import PageHeader from '@/app/customComponents/PageHeader';
import StyledCheckbox from '@shared/components/StyledCheckbox';
import GradientButton from '@shared/components/GradientButton';

const RoomSelection = () => {
	const dispatch = useDispatch();
	const [selectAll, setSelectAll] = useState(false);
	const [allRooms, setAllRooms] = useState([]);
	const [isRoomsLoading, setRoomsLoading] = useState(false);
	const [selectedRooms, setSelectedRooms] = useState([]);
	const [displayParentannouncementForm, setDisplayParentannouncementForm] = useState(false);

	useEffect(() => {
		let isMounted = true;
		setRoomsLoading(true);
		getAllRooms()
			.then(({ data }) => {
				if (!isMounted) return;
				setAllRooms(data);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to fetch data, please refresh',
						variant: 'error',
					})
				);
			})
			.finally(() => {
				if (!isMounted) return;
				setRoomsLoading(false);
			});
		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		if (selectAll) {
			setSelectedRooms(allRooms);
		} else {
			setSelectedRooms([]);
		}
	}, [selectAll]);

	function handleRoomSelection(room) {
		let roomsArray = selectedRooms;

		if (!roomsArray.includes(room)) {
			roomsArray = [...roomsArray, room];
			setSelectedRooms(roomsArray);
			return;
		}
		if (roomsArray.includes(room)) {
			roomsArray = roomsArray.filter((r) => r.id !== room.id);
			setSelectedRooms(roomsArray);
		}
	}

	return (
		<>
			{!displayParentannouncementForm ? (
				<div className="m-32">
					<div className="flex justify-between flex-col sm:flex-row w-full sm:flex-grow gap-20">
						<PageHeader hasBack={false} title="Select Rooms" />
						<FormControl variant="standard">
							<FormControlLabel
								className="flex items-center"
								control={
									<StyledCheckbox
										checked={selectAll}
										className="align-middle pr-6 pb-0"
										name="selectAll"
										onChange={() => setSelectAll(!selectAll)}
										size="small"
										sx={{ color: 'secondary' }}
									/>
								}
								fullWidth
								label={<span className="break-words leading-tight">{!selectAll ? 'S' : 'Des'}elect all</span>}
							/>
						</FormControl>
					</div>
					<div className="bg-white rounded pt-16 mt-28 shadow-card" style={{ paddingBottom: '1px' }}>
						{isRoomsLoading ? (
							<div className="load-spinner text-align-center">
								<CircularProgress size={35} />
							</div>
						) : (
							<div className="grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-16 p-32 max-h-[50vh] overflow-y-scroll">
								{allRooms.map((room, key) => (
									<button
										className="rounded cursor-pointer p-16 shadow-blue-md hover:shadow-blue-sm flex flex-col items-center"
										type="button"
										key={key}
										onClick={() => handleRoomSelection(room)}
									>
										<Avatar
											src={selectedRooms.includes(room) ? 'assets/images/tick.jpg' : room.thumb}
											className="size-40"
										/>
										<p className="text-pd-base font-bold truncate mt-12 max-w-[13ch]">{room.name}</p>
									</button>
								))}
							</div>
						)}
						<div>
							{!isRoomsLoading ? (
								<div className="flex justify-end py-16 pr-16 gap-10 border-t">
									<GradientButton
										onClick={() => {
											if (selectedRooms.length === 0) {
												dispatch(
													Actions.showMessage({
														message: 'Please select the room first!',
														variant: 'error',
													})
												);
											} else {
												setDisplayParentannouncementForm(true);
											}
										}}
										disabled={selectedRooms.length === 0}
										variant={!selectedRooms.length ? 'disabled' : 'blurple'}
										size="small"
									>
										Next
									</GradientButton>
								</div>
							) : null}
						</div>
					</div>
				</div>
			) : null}
			{displayParentannouncementForm ? (
				<AnnouncementForm
					all_room={selectedRooms.length === allRooms.length}
					selectAll={selectAll}
					selectedRooms={selectedRooms}
					setSelectedRooms={setSelectedRooms}
					setActiveTab={() => setDisplayParentannouncementForm(false)}
				/>
			) : null}
		</>
	);
};

export default RoomSelection;
